import { UserLock } from 'lucide-react'
import { Card, CardSubtitle, CardTitle } from '@/shared/components/ui'

/**
 * Pantalla para el miembro CON organización y SIN rol de organización (goal
 * portal-roles-1): pertenece a la organización (su token trae organizationId)
 * pero el dueño aún no le asignó un rol, así que el backend le responde
 * FORBIDDEN en la superficie de organización/negocios/facturación. No es un
 * error: se le explica el estado y a quién pedirle el rol.
 */
export function NoOrgRoleScreen() {
  return (
    <Card className="grid min-h-[480px] place-items-center px-6 py-16 text-center">
      <div className="max-w-md space-y-4">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-soft text-brand">
          <UserLock className="h-7 w-7" />
        </div>
        <CardTitle className="font-serif text-3xl font-normal tracking-tight">
          Aún no tienes un rol asignado
        </CardTitle>
        <CardSubtitle className="text-base">
          Tu cuenta pertenece a la organización, pero todavía no tiene un rol
          asignado dentro de ella. Pídele al dueño de tu organización que te
          asigne uno (Gestor o Contable) para ver sus negocios y su
          facturación.
        </CardSubtitle>
      </div>
    </Card>
  )
}
